import { render } from "./article-overlay-v1.vue?vue&type=template&id=8e1df306"
import script from "./article-overlay-v1.vue?vue&type=script&lang=js"
export * from "./article-overlay-v1.vue?vue&type=script&lang=js"

import "./article-overlay-v1.vue?vue&type=style&index=0&id=8e1df306&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__